<template>
  <div>
    <div class="container" style="background-color: #f3f3f3">
      <div
        class="mb-2 col-12"
        style="border-radius: 0px 0 0px 0;padding: 15px 20px 10px 20px; background-color: #FFFFFF; border-top: 4px; border-top-style: solid; border-bottom: 1px solid #e1e1e1;
        margin-bottom: 0 !important;"
        v-bind:style="{
          'border-top-color': settings.brand.colors.primary
        }"
      >
        <table
          align="center"
          border="0"
          cellpadding="0"
          cellspacing="0"
          role="presentation"
          style="max-width: 640px; "
          width="100%"
          bgcolor="#fff"
        >
          <tbody>
            <tr>
              <td>
                <table
                  align="left"
                  border="0"
                  cellpadding="0"
                  cellspacing="0"
                  class="fw no-max-width"
                  role="presentation"
                  style="max-width: 144px; padding: 15px 20px 15px 20px;"
                >
                  <tbody>
                    <tr>
                      <td class="centeralign" align="center">
                        <a
                          href="#"
                          target="_blank"
                          style="
                                display: inline-block;
                                font-family: Arial, Helvetica, sans-serif;
                                font-size: 22px;
                                color: #ffffff;
                                font-weight: 600;
                                text-decoration: none;"
                        >
                          <img
                            v-if="settings.brand.logos.default"
                            :src="settings.brand.logos.default"
                            alt="logo"
                            style="width: 150px; height: 31px;"
                          />
                          <img
                            v-else
                            src="https://upcdn.io/FW25b8h/raw/templates/emails/logo/rhomtrip-400x83.png"
                            alt="logo"
                            style="width: 150px; height: 31px;"
                          />
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table
                  align="right"
                  border="0"
                  cellpadding="0"
                  cellspacing="0"
                  class="fw no-max-width"
                  role="presentation"
                  style="max-width: 480px;padding: 15px 20px 15px 20px;"
                >
                  <tbody>
                    <tr>
                      <td align="right">
                        <table
                          border="0"
                          cellpadding="0"
                          cellspacing="0"
                          class="fw"
                          role="presentation"
                        >
                          <tbody>
                            <tr>
                              <td
                                class="centeralign"
                                align="right"
                                style="color: #777"
                              >
                                <span
                                  style="
                                      text-transform: capitalize;
                                      display: block;
                                       font-size: 14px; line-height: 16px; font-family: Tahoma, Arial, sans-serif;
                                       ;
                                    "
                                  >September 30, 2024</span
                                >
                                <span
                                  style="
                                        text-transform: capitalize;
                                        display: block;
                                        font-size: 18px; line-height: 22px; font-family: Tahoma, Arial, sans-serif;
                                       font-weight: 600;
                                          color: #000;"
                                  >Reservation Confirmation
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        class="mb-2 col-12 pb-3"
        style="border-radius: 0px 0 10px 10px ;padding: 15px 20px 10px 20px; background-color: #FFFFFF; 
        "
      >
        <table
          align="middle"
          border="0"
          cellpadding="0"
          cellspacing="0"
          role="presentation"
          style="max-width: 640px;border-radius: 0 0 10px 10px;"
          width="100%"
          bgcolor="#fff"
        >
          <tbody>
            <tr>
              <td align="middle" style="vertical-align: middle;">
                <table
                  align="left"
                  border="0"
                  cellpadding="0"
                  cellspacing="0"
                  class="fw no-max-width"
                  role="presentation"
                  style="max-width: 380px; padding: 15px 20px 15px 20px;"
                >
                  <tbody>
                    <tr>
                      <td
                        class="centeralign"
                        align="left"
                        style="font-size: 24px; line-height: 28px; font-family: Tahoma, Arial, sans-serif;color: #000;"
                      >
                        Hi, Mrs. Helen White your reservation is Confirmed!!
                        <span
                          style="font-size: 14px; line-height: 18px; font-family: Tahoma, Arial, sans-serif; color: #777; padding: 15px 0; display: block;"
                        >
                          Thanks for your order. We've provided everything you
                          need for your reservation below.
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style="
                        background-color: #f1f1f1;
                        padding: 10px 15px;
                        margin-top: 20px;
                        border-radius: 8px;
                      "
                      >
                        <span
                          style="
                          display: block;
                          margin-bottom: 0px;
                          font-weight:500;
                           font-size: 16px; line-height: 20px; font-family: Tahoma, Arial, sans-serif;
                        "
                          v-bind:style="{
                            color: settings.brand.colors.primary
                          }"
                        >
                          Reservation ID:
                        </span>
                        <span
                          style="
                          display: block;
                          margin-bottom: 0px;
                           margin-top: 5px;
                          font-weight:500;
                           font-size: 16px; line-height: 20px; font-family: Tahoma, Arial, sans-serif;
                        "
                        >
                          20241001-A00-00001</span
                        >
                        <span
                          style="
                          display: block;
                          margin-bottom: 0px;
                           margin-top: 5px;
                          font-weight:500;
                           font-size: 16px; line-height: 20px; font-family: Tahoma, Arial, sans-serif;
                        "
                          v-bind:style="{
                            color: settings.brand.colors.primary
                          }"
                        >
                          Reservation Reference:
                        </span>
                        <span
                          style="
                          display: block;
                          margin-bottom: 0px;
                           margin-top: 5px;
                          font-weight:500;
                           font-size: 16px; line-height: 20px; font-family: Tahoma, Arial, sans-serif;
                        "
                        >
                          R-12345678</span
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table
                  align="center"
                  border="0"
                  cellpadding="0"
                  cellspacing="0"
                  class="fw no-max-width"
                  role="presentation"
                  style="max-width: 200px;padding: 15px 20px 15px 20px; vertical-align: middle;"
                >
                  <tbody>
                    <tr>
                      <td
                        class="centeralign"
                        align="center"
                        style="color: #777"
                      >
                        <img
                          src="https://upcdn.io/FW25b8h/raw/templates/emails/images/status/rhomtrip-new.png"
                          alt="rhomtrip"
                          width="200"
                          style="display: block; text-align: center"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <table align="center" cellpadding="0" cellspacing="0">
                          <tbody>
                            <tr>
                              <td
                                align="center"
                                style="
                             
                                  border-style: solid;
                                  border-width: 1px;
                                  font: 600 16px/18px Tahoma, Arial,
                                    sans-serif;
                                  margin: 15px 0 0 0;
                                  padding: 8px 25px;
                                  display: inline-block;
                                  border-radius: 20px;
                                  -moz-border-radius: 20px;
                                  -webkit-border-radius: 20px;
                                  text-align: center;
                                "
                                v-bind:style="{
                                  borderColor: settings.brand.colors.primary,
                                  backgroundColor: settings.brand.colors.primary
                                }"
                              >
                                <div
                                  style="
                                  font-size: 16px;
                                  font-weight: 500;
                                  text-decoration: none;                                
                                  
                                "
                                  v-bind:style="{
                                    color: settings.brand.colors.buttonText
                                  }"
                                >
                                  See My Trip
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div>
        <span
          style="
            text-transform: capitalize;
            display: block;
            font-size: 16px; line-height: 20px; font-family: Tahoma, Arial, sans-serif;
            margin: 20px 20px 5px 20px;
            color: #000; 
          "
        >
          <strong style="font-weight: 600;">Service</strong>: Airport Transfer
          (Arrival)
        </span>
      </div>
      <div
        class="mb-2 col-12"
        style="border-radius: 10px;padding: 15px 20px 15px 20px; background-color: #FFFFFF;"
      >
        <table
          align="center"
          border="0"
          cellpadding="0"
          cellspacing="0"
          role="presentation"
          style="max-width: 640px; border-radius: 10px; "
          width="100%"
          bgcolor="#fff"
        >
          <tbody>
            <tr>
              <td style="vertical-align: middle;" align="middle">
                <table
                  align="left"
                  border="0"
                  cellpadding="0"
                  cellspacing="0"
                  class="fw no-max-width"
                  role="presentation"
                  style="max-width: 150px; padding:0px 20px 0px 0px;display: block;"
                >
                  <tbody>
                    <tr>
                      <td class="centeralign" align="center">
                        <img
                          alt="Services RhomTrip"
                          style="width: 100%"
                          src="https://upcdn.io/FW25b8h/raw/templates/emails/images/tesla-model-s.png"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table
                  align="left"
                  border="0"
                  cellpadding="0"
                  cellspacing="0"
                  class="fw no-max-width"
                  role="presentation"
                  style="max-width: 400px;padding: 15px 20px 15px 20px;"
                >
                  <tbody>
                    <tr>
                      <td align="left">
                        <table
                          border="0"
                          cellpadding="0"
                          cellspacing="0"
                          class="fw"
                          role="presentation"
                        >
                          <tbody>
                            <tr>
                              <td
                                class="centeralign"
                                align="left"
                                style="color: #777"
                              >
                                <span
                                  style="
                                   font-size: 18px; line-height: 22px; font-family: Tahoma, Arial, sans-serif;color: #000;display: block;"
                                >
                                  Business Class 3 Seats
                                </span>
                                <span
                                  style="font-size: 14px; line-height: 18px; font-family: Tahoma, Arial, sans-serif;
                                      color: #777;
                                      display: block;
                                      padding: 0 0 0px 0;
                                    "
                                >
                                  Tesla or Similar
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <img
                                  src="https://upcdn.io/FW25b8h/raw/templates/emails/icons/passenger.png"
                                  width="18"
                                  alt="passengers"
                                  style=" vertical-align: middle;"
                                />
                                <span
                                  style="
                                      font-size: 14px; line-height: 18px; font-family: Tahoma, Arial, sans-serif;
                                      color: #777;
                                      margin-right: 5px;
                                    "
                                  >5</span
                                >
                                <img
                                  src="https://upcdn.io/FW25b8h/raw/templates/emails/icons/bags.png"
                                  width="18"
                                  alt="bags"
                                  style="vertical-align: middle;"
                                />
                                <span
                                  style="
                                      font-size: 14px; line-height: 18px; font-family: Tahoma, Arial, sans-serif;
                                      color: #777;
                                      vertical-align: middle;
                                    "
                                  >5</span
                                >
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul
                                  style="
                                    padding-left: 0;
                                    margin-bottom: 0;
                                    font-size: 11px; line-height: 15px; font-family: Tahoma, Arial, sans-serif;
                                    color: #777;
                                    margin-top: 5px;
                                  "
                                >
                                  <li
                                    style="display: inline-block; padding: 2px 8px; border: 1px solid #777; margin-right: 3px; border-radius: 20px;"
                                  >
                                    WiFi onboard
                                  </li>
                                  <li
                                    style="display: inline-block; padding: 2px 8px; border: 1px solid #777; margin-right: 3px; border-radius: 20px;"
                                  >
                                    Water
                                  </li>
                                  <li
                                    style="display: inline-block; padding: 2px 8px; border: 1px solid #777; margin-right: 3px; border-radius: 20px;"
                                  >
                                    Hand Sanitizer
                                  </li>
                                </ul>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div>
        <span
          style="
            text-transform: capitalize;
            display: block;
            font-size: 16px; line-height: 20px; font-family: Tahoma, Arial, sans-serif;
            margin: 20px 20px 5px 20px;
            color: #000; 
          "
        >
          <strong style="font-weight: 600;">Reservation for</strong>:
          10-dec-2024 at 12:00 (12:00 PM)
        </span>
      </div>

      <div
        class="mb-2 col-12"
        style="border-radius: 10px;padding: 15px 20px 15px 20px; background-color: #FFFFFF;"
      >
        <td
          align="middle"
          style="vertical-align: middle; border-radius: 10px;"
          bgcolor="#fff"
        >
          <table
            align="left"
            border="0"
            cellpadding="0"
            cellspacing="0"
            class="fw no-max-width"
            role="presentation"
            style="max-width: 100%; padding: 15px 20px 15px 20px;"
          >
            <tbody>
              <tr>
                <td>
                  <table cellpadding="0" cellspacing="0" width="100% ">
                    <tbody>
                      <tr>
                        <td width="1">
                          <table cellpadding="0" cellspacing="0" width="100% ">
                            <tbody>
                              <tr>
                                <td style="line-height: 0">
                                  <img
                                    src="https://upcdn.io/FW25b8h/raw/templates/emails/icons/pointa.png"
                                    align="left "
                                    vspace="0 "
                                    hspace="0 "
                                    width="20"
                                    alt="point-a"
                                    style=" vertical-align: top;"
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        <td width="10"></td>
                        <td>
                          <table cellpadding="0" cellspacing="0" width="100% ">
                            <tbody>
                              <tr>
                                <td
                                  style="
                                    font-size: 14px; line-height: 13px; font-family: Tahoma, Arial, sans-serif; 
                                    color: #777;
                                    padding: 0 0 3px;
                                  "
                                >
                                  Pickup
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style="
                                      font-size: 16px; line-height: 19px; font-family: Tahoma, Arial, sans-serif; 
                                    color: #000;
                                  "
                                >
                                  Los Angeles International Airport | LAX, Los
                                  Angeles, US
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>

              <tr>
                <td height="10"></td>
              </tr>
              <tr>
                <td>
                  <table cellpadding="0" cellspacing="0" width="100%">
                    <tbody>
                      <tr>
                        <td width="19">
                          <table cellpadding="0" cellspacing="0" width="100%">
                            <tbody>
                              <tr>
                                <td style="line-height: 0">
                                  <img
                                    src="https://upcdn.io/FW25b8h/raw/templates/emails/icons/point-b.png"
                                    align="left "
                                    vspace="0 "
                                    hspace="0 "
                                    width="20"
                                    alt="point-b"
                                    style=" vertical-align: top;"
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        <td width="8 "></td>
                        <td>
                          <table cellpadding="0 " cellspacing="0" width="100% ">
                            <tbody>
                              <tr>
                                <td
                                  style="font-size: 14px; line-height: 13px; font-family: Tahoma, Arial, sans-serif; 
                                      color: #777;
                                      padding: 0 0 3px;
                                    "
                                >
                                  Dropoff
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style="
                                    font-size: 16px; line-height: 19px; font-family: Tahoma, Arial, sans-serif; 
                                    color: #000;
                                  "
                                >
                                  Ackerman Avenue, Santa Clarita, CA, USA
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </div>

      <div
        class="mb-2 col-12"
        style="border-radius: 10px;padding: 15px 20px 15px 20px; background-color: #FFFFFF;"
      >
        <div class="row">
          <div class="col-xl-12 mb-2">
            <span
              style="
                  font-size: 14px; line-height: 13px; font-family: Tahoma, Arial, sans-serif; 
                  color: #777;
                  padding: 0 0 3px;
                  display: block;
                "
            >
              Nº Passengers
            </span>
            <span
              style="color: #000; font-size: 16px; line-height: 20px; font-family: Tahoma, Arial, sans-serif; padding-bottom: 15px;"
              >2 Adults / 0 Children</span
            >
          </div>
        </div>

        <table style="border-collapse: collapse;">
          <thead>
            <tr>
              <th
                align="left"
                width="45%"
                style="padding-right: 15px;
                    padding-bottom: 0px;
                  "
              >
                <span
                  style="
                  font-size: 14px; line-height: 13px; font-family: Tahoma, Arial, sans-serif; 
                  color: #777;
                  padding: 0 0 3px;
                  display: block; font-weight: 400;"
                >
                  Passengers
                </span>
              </th>
              <th
                align="left"
                width="30%"
                style="
                    padding-right: 15px;
                    padding-bottom: 0px;
                    text-decoration: none;
                  "
              >
                <span
                  style="
                  font-size: 14px; line-height: 13px; font-family: Tahoma, Arial, sans-serif; 
                  color: #777;
                  padding: 0 0 3px;
                  display: block;
                  font-weight: 400;
                "
                >
                  Phone
                </span>
              </th>

              <th
                align="left"
                width="10%"
                style="                       
                    padding-right: 15px;
                    padding-bottom: 0px;
                  "
              >
                <span
                  style="
                  font-size: 14px; line-height: 13px; font-family: Tahoma, Arial, sans-serif; 
                  color: #777;
                  padding: 0 0
                    3px;
                  display: block;font-weight: 400;
                "
                >
                  Type
                </span>
              </th>

              <th
                align="left"
                width="15%"
                style="padding-right: 15px; padding-bottom: 0px;"
              >
                <span
                  style="
                  font-size: 14px; line-height: 13px; font-family: Tahoma, Arial, sans-serif; 
                  color: #777;
                  padding: 0 0 3px;
                  display: block;font-weight: 400;
                "
                >
                  Flight Nº
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td
                style="                       
                    padding-right: 15px;
                    padding-bottom: 5px;
                  "
              >
                <span
                  style="color: #000; font-size: 16px; line-height: 20px; font-family: Tahoma, Arial, sans-serif; padding-bottom: 15px;"
                  >Mrs. Helen White</span
                >
              </td>
              <td
                style="                       
                    padding-right: 15px;
                    padding-bottom: 5px;
                  "
              >
                <span
                  v-bind:style="{
                    color: settings.brand.colors.primary
                  }"
                  style="
                        font-size: 16px; line-height: 20px; font-family: Tahoma, Arial, sans-serif;
                      "
                >
                  +54 3417202630
                </span>
              </td>
              <td
                style="                       
                    padding-right: 15px;
                    padding-bottom: 5px;
                  "
              >
                <span
                  style="color: #000; font-size: 16px; line-height: 20px; font-family: Tahoma, Arial, sans-serif; padding-bottom: 15px;"
                  >ADULT</span
                >
              </td>
              <td
                style="                       
                    padding-right: 15px;
                    padding-bottom: 5px;
                  "
              >
                <span
                  style="color: #000; font-size: 16px; line-height: 20px; font-family: Tahoma, Arial, sans-serif; padding-bottom: 15px;"
                  >AA123</span
                >
              </td>
            </tr>
          </tbody>
        </table>

        <div class="row">
          <div class="col-xl-12 mt-2 mb-2">
            <span
              style="
                  font-size: 14px; line-height: 13px; font-family: Tahoma, Arial, sans-serif; 
                  color: #777;
                  padding: 0 0 3px;
                  display: block;
                "
            >
              Pickup Sign
            </span>
            <span
              style="color: #000; font-size: 16px; line-height: 20px; font-family: Tahoma, Arial, sans-serif; padding-bottom: 15px;"
              >Mrs. Helen White</span
            >
          </div>

          <div class="col-xl-12">
            <span
              style="
                  font-size: 14px; line-height: 13px; font-family: Tahoma, Arial, sans-serif; 
                  color: #777;
                  padding: 0 0 3px;
                  display: block;
                "
            >
              Special Requirements
            </span>
            <span
              style="color: #000; font-size: 16px; line-height: 20px; font-family: Tahoma, Arial, sans-serif; padding-bottom: 15px;"
              >None</span
            >
          </div>
        </div>
      </div>

      <div>
        <span
          style="
            text-transform: capitalize;
            display: block;
            font-size: 16px; line-height: 20px; font-family: Tahoma, Arial, sans-serif;
            margin: 20px 20px 5px 20px;
            color: #000; 
          "
        >
          <strong style="font-weight: 600;">Breakdown of Charges</strong>
        </span>
      </div>

      <div
        style="border-radius: 10px;padding: 15px 20px 15px 20px; background-color: #FFFFFF;"
      >
        <table style="width: 100%; border-collapse: collapse">
          <tbody>
            <tr>
              <th width="60%" align="left" style="padding: 3px 5px;">
                <span
                  style="font-size: 14px; line-height: 17px; font-family: Tahoma, Arial, sans-serif; color:#000000;"
                >
                  DESCRIPTION</span
                >
              </th>
              <th
                align="right"
                width="40%"
                style="padding: 3px 5px;  text-align: right;"
              >
                <span
                  style="font-size: 14px; line-height: 17px; font-family: Tahoma, Arial, sans-serif;
                    text-align: right; color:#000000;"
                >
                  PRICE</span
                >
              </th>
            </tr>
            <tr>
              <td style="padding: 3px 5px; ">
                <span
                  style="color:#000000;font-size: 14px; line-height: 17px; font-family: Tahoma, Arial, sans-serif;text-align: right;"
                >
                  Base Price</span
                >
              </td>
              <td
                style="
                    padding: 3px 5px;  text-align: right;"
              >
                <span
                  style="
                  color:#000000;
                    font-size: 14px; line-height: 17px; font-family: Tahoma, Arial, sans-serif;
                    text-align: right;"
                  >€ 135.92 EUR
                </span>
              </td>
            </tr>

            <tr>
              <td style="padding: 3px 5px;">
                <span
                  style="color:#000000;font-size: 14px; line-height: 17px; font-family: Tahoma, Arial, sans-serif;"
                >
                  Extra Charge: Multiple pick up/Drop off points</span
                >
              </td>
              <td align="right" style="padding: 3px 5px;">
                <span
                  style="
                    color:#000000;font-size: 14px; line-height: 17px; font-family: Tahoma, Arial, sans-serif;
                    text-align: right;"
                  >€67.00 EUR
                </span>
              </td>
            </tr>
            <tr>
              <td style="padding: 3px 5px;">
                <span
                  style="
                    color:#000000;font-size: 14px; line-height: 17px; font-family: Tahoma, Arial, sans-serif;
                    text-align: right;"
                  >Discount: 20%
                </span>
              </td>
              <td align="right" style="padding: 3px 5px;">
                <span
                  style="
                    color:#000000;font-size: 14px; line-height: 17px; font-family: Tahoma, Arial, sans-serif;
                    text-align: right;"
                  >- €20.00 EUR</span
                >
              </td>
            </tr>
            <tr>
              <td
                style="padding: 10px 5px 3px 5px; margin-top: 10px;
                      padding: 3px 5px;
                      border-top: 1px solid #e1e1e1;"
              >
                <span
                  style="font-weight:600; color:#000000;text-transform:uppercase; font-size: 14px; line-height: 17px; font-family: Tahoma, Arial, sans-serif;"
                >
                  TOTAL PRICE</span
                >
              </td>
              <td
                align="right"
                style="
                    padding: 10px 5px 3px 5px; margin-top: 10px;border-top: 1px solid #e1e1e1;"
              >
                <span
                  style="font-weight:600; color:#000000;text-align: right; font-size: 14px; line-height: 17px; font-family: Tahoma, Arial, sans-serif;"
                  >€ 372.92 EUR</span
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        style="padding: 30px 30px 30px 30px; margin-top:20px; "
        v-bind:style="{
          backgroundColor: settings.brand.colors.primary
        }"
      >
        <div class="row">
          <div class="col-xl-8 align-self-center">
            <span
              v-bind:style="{
                color: settings.brand.colors.buttonText
              }"
              style="font-size: 22px; line-height: 26px; font-family: Tahoma, Arial, sans-serif;  display: block;"
            >
              Check your reservation now!</span
            >
            <span
              v-bind:style="{
                color: settings.brand.colors.buttonText
              }"
              style="font-size: 14px; line-height: 18px; font-family: Tahoma, Arial, sans-serif;padding: 10px 0 0 0; display: block;"
            >
              Click the button to access your reservation details and ensure
              everything is set for your trip. We're here to make your
              experience perfect!
            </span>
          </div>
          <div class="col-xl-4 text-center align-self-center">
            <div
              v-bind:style="{
                backgroundColor: settings.brand.colors.buttonText,
                color: settings.brand.colors.primary
              }"
              style=" font-size: 16px;
                      font-weight: 500;
                      text-decoration: none; 
                      font-size: 16px; line-height: 18px; font-family: Tahoma, Arial, sans-serif;
                      border-style: solid;
                      border-width: 1px;
                      padding: 10px 25px;
                      display: inline-block;
                      border-radius: 20px;
                      -moz-border-radius: 20px;
                      -webkit-border-radius: 20px;
                      text-align: center;"
            >
              See My Trip
            </div>
          </div>
        </div>
      </div>

      <div style=" margin: 25px 0px 5px 0px;">
        <span
          style="text-transform: capitalize;display: block;font-size: 16px; line-height: 20px; font-family: Tahoma, Arial, sans-serif; margin: 25px 20px 5px 20px;color:#000000; font-weight: 600;"
        >
          Cancellation Policies
        </span>
        <ul
          style="padding:0px 25px 0px 40px;font-size: 14px; line-height: 18px; font-family: Tahoma, Arial, sans-serif;color:#000000; list-style-type: disc;"
        >
          <li>
            Changes made less than 25 Hours before the experience's start time
            will not be accepted.
          </li>
          <li>
            To receive a Full Refund, cancellations must be made at least 48
            Hours prior to the start time of the experience.
          </li>
          <li>
            To receive a 25 % refund, cancellations must be made at least 24
            Hours prior to the start time of the experience.
          </li>
          <li>
            If you cancel less than 24 Hours before the experience's start time,
            the amount you paid will not be refunded.
          </li>
        </ul>
      </div>

      <!-- <div
        style="padding: 0px 20px 10px 20px"
        v-if="settings.brand.notifications.importantNote"
      >
        <span
          style="text-transform: capitalize;display: block;font-size: 16px; line-height: 20px; font-family: Tahoma, Arial, sans-serif; margin: 25px 0px 5px 0px;color:#000000; font-weight: 600;"
        >
          Important Information
        </span>

        <p
          style="font-size: 14px; line-height: 18px; font-family: Tahoma, Arial, sans-serif; color:#000000 !important;"
        >
          {{ settings.brand.notifications.importantNote }}
        </p>
      </div> -->

      <div>
        <table
          width="100%"
          cellspacing="0"
          cellpadding="0"
          bgcolor="#f3f3f3"
          style=""
          v-if="
            settings.entityDetails.contact.phoneNumber ||
              settings.entityDetails.contact.email
          "
        >
          <tbody>
            <tr>
              <td>
                <table
                  border="0"
                  cellpadding="0"
                  cellspacing="0"
                  role="presentation"
                  style="min-width: 100%"
                  width="100%"
                >
                  <tbody>
                    <tr>
                      <td align="center" height="100%" width="100%">
                        <table
                          align="center"
                          border="0"
                          cellpadding="0"
                          cellspacing="0"
                          role="presentation"
                          style="max-width: 640px;background-image: url('https://upcdn.io/FW25b8h/raw/templates/emails/images/back-contact-us.png'); background-size: cover; background-position: center; border-collapse: collapse;"
                          width="100%"
                        >
                          <tbody>
                            <tr>
                              <td
                                align="center"
                                style="
                              
                              display: block;
                            
                              margin: 30px 20px 10px 20px;
                            "
                              >
                                <span
                                  style="font-weight: 600; font-size: 20px; line-height: 24px; font-family: Tahoma, Arial, sans-serif; text-transform: capitalize;"
                                >
                                  <strong>Have a Question?</strong>
                                </span>
                              </td>
                            </tr>

                            <tr>
                              <td align="center" height="100%" width="100%">
                                <table
                                  align="center"
                                  border="0"
                                  cellpadding="0"
                                  cellspacing="0"
                                  role="presentation"
                                  style="max-width: 640px; border-radius: 10px; "
                                  width="100%"
                                >
                                  <tbody>
                                    <tr>
                                      <td>
                                        <table
                                          align="center"
                                          border="0"
                                          cellpadding="0"
                                          cellspacing="0"
                                          class="fw no-max-width"
                                          role="presentation"
                                        >
                                          <tbody>
                                            <tr>
                                              <td
                                                v-if="
                                                  settings.entityDetails.contact
                                                    .phoneNumber
                                                "
                                                class="centeralign"
                                                align="center"
                                                style="padding: 15px 20px 15px 20px;"
                                              >
                                                <a
                                                  :href="
                                                    `tel:${settings.entityDetails.contact.phoneNumber}`
                                                  "
                                                  target="_blank"
                                                  style="text-decoration: none; font-weight: 600; font-size: 16px; line-height: 20px; font-family: Tahoma, Arial, sans-serif; color: #777;"
                                                >
                                                  <img
                                                    style="width: 50%"
                                                    src="https://upcdn.io/FW25b8h/raw/templates/emails/images/call-phone.png"
                                                    alt="call"
                                                  />
                                                  <span
                                                    style="display: block;margin-top: 10px;"
                                                    >Give us a Call</span
                                                  >
                                                </a>
                                              </td>
                                              <td
                                                v-if="
                                                  settings.entityDetails.contact
                                                    .email
                                                "
                                                class="centeralign"
                                                align="center"
                                                style="padding: 15px 20px 15px 20px;"
                                              >
                                                <a
                                                  :href="
                                                    `mailto:${settings.entityDetails.contact.email}`
                                                  "
                                                  target="_blank"
                                                  style="text-decoration: none;font-weight: 600; font-size: 16px; line-height: 20px; font-family: Tahoma, Arial, sans-serif; color: #777;"
                                                >
                                                  <img
                                                    style="width: 50%"
                                                    src="https://upcdn.io/FW25b8h/raw/templates/emails/images/send-email.png"
                                                    alt="message"
                                                  />
                                                  <span
                                                    style="display: block;margin-top: 10px;"
                                                    >Message Us</span
                                                  >
                                                </a>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div style="padding: 0px 20px 10px 20px" class="text-center">
        <a
          v-if="settings.entityDetails.pages.web"
          :href="settings.entityDetails.pages.web"
          style="
                color: #666666;
                font-size: 14px; line-height: 16px; font-family: Tahoma, Arial, sans-serif;
                text-decoration: none;
                display: block;
              "
          target="_blank"
        >
          <img
            v-if="settings.brand.logos.favicon"
            :src="settings.brand.logos.favicon"
            alt="logo"
            style="width: 60px; height: 60px; margin-bottom: 10px;"
          />
        </a>

        <a
          v-if="settings.socialmedia.linkedin"
          :href="settings.socialmedia.linkedin"
          style="margin: 3px; text-decoration: none"
          target="_blank"
        >
          <img
            style="width: 25px; height: auto"
            src="https://upcdn.io/FW25b8h/raw/templates/emails/icons/social-media/linkedin.png"
            alt="linkedin"
          />
        </a>

        <a
          v-if="settings.socialmedia.instagram"
          :href="settings.socialmedia.instagram"
          style="margin: 3px; text-decoration: none"
          target="_blank"
        >
          <img
            style="width: 25px; height: auto"
            src="https://upcdn.io/FW25b8h/raw/templates/emails/icons/social-media/instagram-1.png"
            alt="instagram"
          />
        </a>

        <a
          v-if="settings.socialmedia.facebook"
          :href="settings.socialmedia.facebook"
          style="margin: 3px; text-decoration: none"
          target="_blank"
        >
          <img
            style="width: 25px; height: auto"
            src="https://upcdn.io/FW25b8h/raw/templates/emails/icons/social-media/facebook.png"
            alt="facebook"
          />
        </a>
        <a
          v-if="settings.socialmedia.twitter"
          :href="settings.socialmedia.twitter"
          style="margin: 3px; text-decoration: none"
          target="_blank"
        >
          <img
            style="width: 25px; height: auto"
            src="https://upcdn.io/FW25b8h/raw/templates/emails/icons/social-media/twitter.png"
            alt="twitter"
          />
        </a>
      </div>

      <div
        class="text-center"
        style=" border-top: 1px solid rgba(0, 0, 0, 0.1); padding: 10px 20px 20px 20px;font-size: 10px; line-height: 14px; font-family: Tahoma, Arial, sans-serif;
            color: #666666;"
      >
        <p
          style="margin-bottom: 5px; font-size: 10px; line-height: 14px; font-family: Tahoma, Arial, sans-serif;"
        >
          You received this email because you're subscribed to
          {{ settings.entityDetails.company.name }}.
        </p>

        <p
          style="margin: 0 0 5px 0; font-size: 10px; line-height: 14px; font-family: Tahoma, Arial, sans-serif;"
        >
          © {{ year }}. {{ settings.entityDetails.company.name }}. All Rights
          Reserved.
        </p>

        <a
          :href="settings.entityDetails.pages.contact"
          style="color: #666666; font-size: 10px; line-height: 14px; font-family: Tahoma, Arial, sans-serif;"
          target="_blank"
          v-if="settings.entityDetails.pages.contact"
        >
          Contacts |
        </a>

        <a
          :href="settings.entityDetails.termsConditions"
          style="color: #666666; font-size: 10px; line-height: 14px; font-family: Tahoma, Arial, sans-serif;"
          target="_blank"
          v-if="settings.entityDetails.termsConditions"
        >
          Terms & Conditions |
        </a>

        <a
          href="#"
          target="_blank"
          style="color: #666666; font-size: 10px; line-height: 14px; font-family: Tahoma, Arial, sans-serif;"
        >
          Unsubscribe
        </a>

        <p
          style="margin: 5px 0 5px 0; font-size: 10px; line-height: 14px; font-family: Tahoma, Arial, sans-serif;"
        >
          Powered by RhomTrip OÜ. All Rights Reserved.
        </p>
      </div>
      <div
        class="text-center"
        style=" border-top: 1px solid rgba(0, 0, 0, 0.1); padding: 10px 20px 20px 20px;
                            color: #666666;"
      >
        <p
          style="margin-bottom: 5px; font-style: italic; font-size: 10px; line-height:11px;font-family:Tahoma, Arial, sans-serif;"
        >
          <strong>Disclaimer:</strong>
          RhomTrip OÜ distributes its services through a network of independent
          Agencies and Agents. While we strive to ensure the highest standards
          of quality and professionalism among our collaborators, RhomTrip OÜ
          cannot be held liable for actions, decisions, or communications made
          independently by these Agencies or Agents outside the scope of our
          official agreements. For verification of this message or any related
          information, please contact us directly via our official channels.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "preview-new-reservation-customer",
  props: {
    settings: {
      type: Object,
      default: null,
      description: "Operator Brand"
    },
    companyName: {
      type: String,
      default: "RhomTrip",
      description: "companyName"
    }
  },
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
